<section class="toasts" aria-label="Notifications">
  <div class="toasts__list" [id]="listId" role="status" aria-live="polite" aria-relevant="additions text">
    @for (toast of visible(); track toast.id) {
    <div
      class="toast"
      [attr.data-tone]="toast.tone"
      [class.is-leaving]="toast.leaving"
      (pointerenter)="onPointerEnter($event, toast.id)"
      (pointerleave)="onPointerLeave($event, toast.id)"
      (focusin)="service.pause(toast.id)"
      (focusout)="service.resume(toast.id)"
    >
      <span class="toast__dot" aria-hidden="true"></span>
      <div class="toast__text">
        @if (toast.title) {
        <p class="toast__title">{{ toast.title }}</p>
        }
        <p class="toast__message">{{ toast.message }}</p>
      </div>
      <button
        type="button"
        class="bk-icon-btn toast__close"
        aria-label="Dismiss notification"
        (click)="service.dismiss(toast.id)"
      >
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </div>
    }
  </div>
</section>
